export const VISITOR_TYPES = [
  { value: 'visitor', label: 'Visitor' },
  { value: 'parent_guardian', label: 'Parent/Guardian' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'volunteer', label: 'Volunteer' },
  { value: 'other', label: 'Other' },
];

export const VISIT_REASONS = [
  { value: 'meeting', label: 'Meeting' },
  { value: 'student_pickup', label: 'Student Pickup' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'volunteering', label: 'Volunteering' },
  { value: 'event', label: 'Event' },
  { value: 'other', label: 'Other' },
];

export const RESTRICTION_SEVERITIES = [
  { value: 'alert_only', label: 'Alert Only' },
  { value: 'do_not_admit', label: 'Do Not Admit' },
];

const TYPE_LABELS = Object.fromEntries(VISITOR_TYPES.map((item) => [item.value, item.label]));
const REASON_LABELS = Object.fromEntries(VISIT_REASONS.map((item) => [item.value, item.label]));
const SEVERITY_LABELS = Object.fromEntries(RESTRICTION_SEVERITIES.map((item) => [item.value, item.label]));

export function visitorTypeLabel(value) {
  return TYPE_LABELS[value] || 'Visitor';
}

export function visitReasonLabel(value) {
  return REASON_LABELS[value] || 'Other';
}

export function severityLabel(value) {
  return SEVERITY_LABELS[value] || value;
}

export function createClientRequestId() {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : undefined;
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
  return `req-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function emptyCheckInForm() {
  return {
    fullName: '',
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    birthDate: '',
    identityExtracted: false,
    visitorType: 'visitor',
    visitReason: 'meeting',
    destinationLabel: '',
    destinationStaffId: null,
    company: '',
    notes: '',
    visitorId: null,
  };
}

export function validateCheckInForm(form) {
  if (!String(form.fullName || '').trim()) return 'Full name is required.';
  if (!TYPE_LABELS[form.visitorType]) return 'Choose a visitor type.';
  if (!REASON_LABELS[form.visitReason]) return 'Choose a visit reason.';
  return '';
}

export function printStatusLabel(status) {
  switch (status) {
    case 'confirmed':
      return 'Printed';
    case 'accepted':
      return 'Print accepted, not confirmed';
    case 'failed':
      return 'Print failed';
    case 'unavailable':
      return 'Printer unavailable';
    default:
      return 'Not printed';
  }
}

export function formatCalendarDate(value) {
  const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatVisitWhen(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
